import { theme } from "antd";
import type { ChatBlock } from "./chat-block.types";

type Props = {
	block: ChatBlock;
};

// Safety net for an unknown or not-yet-supported block type. Renders a small,
// non-alarming note instead of raw JSON. This is what lets the backend ship a
// new block type before its renderer lands on the client (graceful degradation).
export function UnsupportedBlock({ block }: Props) {
	const { token } = theme.useToken();

	return (
		<div
			style={{
				fontSize: 12,
				color: token.colorTextTertiary,
				fontStyle: "italic",
				padding: "2px 0",
			}}
		>
			This response includes a “{block.type}” block this app can’t show yet.
		</div>
	);
}
